<div
  #drawer
  class="drawer"
  [ngClass]="[ orientation, opened ? 'opened' : 'closed' ]"
>
  <ng-content></ng-content>
</div>
